<template>
  <overlay
    key="searchDrawer"
    :block-class="`${direction} search-drawer-overlay`"
    :direction="direction"
    namespace="searchDrawer"
    :overlay-label="$string('general.site_header.search')"
    :template="false"
    type="drawer"
    disable-update-focussed-element
  >
    <template #body="overlay">
      <search-drawer
        :overlay="overlay"
        :menu="menu"
        :site-id="siteId"
        :articles-site-id="articlesSiteId"
        :pages-site-id="pagesSiteId"
        :show-page-and-article-results="showPageAndArticleResults"
        :show-collection-results="showCollectionResults"
        :enable-suggested-terms-target-collection="enableSuggestedTermsTargetCollection"
      />
    </template>
  </overlay>
</template>

<script>

/**
 * Vue: Search drawer overlay (search-drawer-overlay)
 * -----------------------------------------------------------------------------
 * A SearchSpring Search drawer overlay.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {Object} menu - Section's Liquid quick links menu.
 * @param {String} siteId - Searchspring site id.
 * @param {String} articlesSiteId - Searchspring site id.
 * @param {String} pagesSiteId - Searchspring site id.
 * @param {String} showPageAndArticleResults - Whether to show pages/articles
 */
// eslint-disable-next-line import/named
import { mapActions } from 'vuex'

import Overlay from '~global/overlay/overlay'
import SearchDrawer from '~global/search-drawer-group/search-drawer/search-drawer'

export default {
  name: 'SearchDrawerOverlay',

  components: {
    Overlay,
    SearchDrawer,
  },

  props: {
    menu: {
      type: Object,
      default: () => ({}),
    },
    siteId: {
      type: String,
      required: true,
    },
    articlesSiteId: {
      type: String,
      default: '',
    },
    pagesSiteId: {
      type: String,
      default: '',
    },
    showPageAndArticleResults: {
      type: Boolean,
      default: true,
    },
    showCollectionResults: {
      type: Boolean,
      default: true,
    },
    enableSuggestedTermsTargetCollection: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      direction: 'left',
    }
  },

  created() {
    window.cnvs?.EventBus?.listen('overlay:open-search-drawer', (direction) => {
      this.direction = direction

      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'searchDrawer',
      })
    })
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),
  },
}
</script>
